// extracted by mini-css-extract-plugin
module.exports = {"Content":"SliderContent_Content__2W5-6","firstTitle":"SliderContent_firstTitle__2EXD0","secondTitle":"SliderContent_secondTitle__1_Rqv","para":"SliderContent_para__36dW1"};